export default [
  {
    header: 'counselings.mainVerticalMenu.counselings',
    resource: 'counseling',
    action: 'read',
  },
  {
    title: 'counselings.mainVerticalMenu.counselingsList',
    icon: 'MessageSquareIcon',
    resource: 'counseling',
    action: 'read',
    route: 'pages-counseling-list',
  },
  {
    title: 'counselings.mainVerticalMenu.emptyCounselings',
    icon: 'MessageCircleIcon',
    resource: 'counseling',
    action: 'read',
    route: 'pages-counseling-empty',
  },
  {
    title: 'counselings.mainVerticalMenu.noResponseCounselings',
    icon: 'LogInIcon',
    resource: 'counseling',
    action: 'report',
    route: 'pages-counseling-no-response',
  },
  {
    title: 'counselings.transferCounseling',
    icon: 'ShuffleIcon',
    resource: 'counseling',
    action: 'transfer',
    route: 'pages-counseling-transfer',
  },
]
